/**
 * @generated SignedSource<<19570ed146a186fdd21d49f26d244652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisconnectOrgSlackMutation$variables = {
  organisationId: string;
};
export type DisconnectOrgSlackMutation$data = {
  readonly disconnectOrganisationFromSlack: {
    readonly __typename: "ForbiddenError";
    readonly reason: string;
  } | {
    readonly __typename: "NotFoundError";
    readonly reason: string;
  } | {
    readonly __typename: "OrganisationDisconnectedFromSlack";
    readonly organisationId: string;
    readonly success: boolean;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type DisconnectOrgSlackMutation = {
  response: DisconnectOrgSlackMutation$data;
  variables: DisconnectOrgSlackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organisationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reason",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "organisationId",
        "variableName": "organisationId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "disconnectOrganisationFromSlack",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationId",
            "storageKey": null
          }
        ],
        "type": "OrganisationDisconnectedFromSlack",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "ForbiddenError",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "NotFoundError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisconnectOrgSlackMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisconnectOrgSlackMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "93569a93f241a7f93cc3de71532bb05b",
    "id": null,
    "metadata": {},
    "name": "DisconnectOrgSlackMutation",
    "operationKind": "mutation",
    "text": "mutation DisconnectOrgSlackMutation(\n  $organisationId: ID!\n) {\n  disconnectOrganisationFromSlack(organisationId: $organisationId) {\n    __typename\n    ... on OrganisationDisconnectedFromSlack {\n      success\n      organisationId\n    }\n    ... on ForbiddenError {\n      reason\n    }\n    ... on NotFoundError {\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8da2d44bc58bb65d334770de7ff3e40a";

export default node;
